import Vue from 'vue';
import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { SET_PRELOADER_PROGRESS, SET_PRELOADER_STATUS } = LOCAL;

const SET_MANIFEST = "setManifest";
const SAVE_LOADED_FILE = "saveLoadedFile";

export default {
	namespaced: true,
	state: {
		manifest: {},
		progress: 0,
		loaded: false,
		list: {},
	},
	getters: {
		get: (state) => (id) => state.list[id],
	},
	actions: {
		configureApp: {
			root: true,
			handler({ dispatch }, configData) {
				dispatch("loadManifest", configData.preload);
			},
		},
		loadManifest({ commit, dispatch }, manifest) {
			commit(SET_MANIFEST, manifest);
			commit(SET_PRELOADER_STATUS, { loaded: false });

			Object.values(manifest).forEach((file) => {
				dispatch("loadFile", file);
			});
		},
		async loadFile({ dispatch, commit, state }, file) {
			if (!state.list[file.id]) {
				fetch(file.url).then((response) => response.blob()).then((blob) => {
					const url = URL.createObjectURL(blob);
					commit(SAVE_LOADED_FILE, { ...file, url, raw: file.url });
					dispatch("assetLoad", { ...file }, ROOT_FLAG);
				});
			}
		},
	},
	mutations: {
		[SET_MANIFEST](state, manifest) {
			state.manifest = { ...manifest };
		},
		[SAVE_LOADED_FILE](state, file) {
			Vue.set(state.list, file.id, file);
			Vue.delete(state.manifest, file.id);

			const remainingManifestItemCount = Object.values(state.manifest).length;
			const remainingProgress = (1 - state.progress);
			state.progress += !remainingManifestItemCount
				? remainingProgress : (remainingProgress / remainingManifestItemCount);

			if (!remainingManifestItemCount) {
				state.loaded = true;
			}
		},
		[SET_PRELOADER_PROGRESS](state, event) {
			state.progress = event.progress;
		},
		[SET_PRELOADER_STATUS](state, event) {
			state.loaded = event.loaded;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/global/assets.store.js